<template>
  <q-timeline-entry>
    <template
      v-for="(slot, index) of Object.keys($slots)"
      :key="index"
      #[slot]="slotProps"
    >
      <slot v-if="slotProps" v-bind="slotProps" :name="slot"></slot>
      <slot v-else :name="slot"></slot>
    </template>
  </q-timeline-entry>
</template>

<script setup></script>
